import { Link } from 'react-router-dom';

import { ContactForm } from '../../components/contact-form';

export default function ControlMaps() {
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>
        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Resources / Control Maps</div>
          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            Control maps
            <br />
            that engineers can execute
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Practical mappings: regulation → control → technology capability → evidence artifact → audit method.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/technology-mapping" className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#10B981] to-[#059669] px-5 text-sm font-semibold text-white hover:opacity-95">
              Open mapping hub →
            </Link>
            <Link to="/resources" className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary hover:bg-white/10">
              Back to resources
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-background-primary py-20">
        <div className="container-ivalue">
          <div className="grid gap-4 lg:grid-cols-3">
            {[ 
              {
                t: "DPDPA Consent → CMP → Consent Logs",
                d: "Link DPDPA consent controls to consent platform configuration + immutable consent audit trails.",
                href: "/frameworks/india/dpdpa",
              },
              {
                t: "RBI SOC controls → SIEM Use-cases",
                d: "Map SOC obligations to log sources, detection logic, and incident runbooks.",
                href: "/frameworks/india/rbi",
              },
              {
                t: "Cross-border transfer → Data flow mapping",
                d: "Connect notices, country whitelists, transfer logs, and contractual safeguards.",
                href: "/frameworks/india/dpdpa#crossmap",
              },
            ].map((x) => (
              <div key={x.t} className="glass-card sheen p-6">
                <div className="text-lg font-semibold text-text-primary">{x.t}</div>
                <div className="mt-2 text-sm text-text-secondary">{x.d}</div>
                <div className="mt-5">
                  <Link to={x.href} className="focus-ring inline-flex h-11 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-4 text-sm font-semibold text-text-primary hover:bg-white/10">
                    View reference →
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 glass-card p-6">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Recommended mapping approach</div>
            <div className="mt-4 grid gap-3 md:grid-cols-2">
              {[
                { t: "Start with domains", d: "Group controls into operational domains (Consent, Rights, Security, Vendors)." },
                { t: "Define evidence", d: "For each control, define the evidence source (log/report/config) and retention." },
                { t: "Pick enablers", d: "Map technology categories to capabilities (CMP, DSAR, DSPM, SIEM, GRC)." },
                { t: "Make it testable", d: "Add audit method: sampling, config checks, drills, and continuous monitoring." },
              ].map((x) => (
                <div key={x.t} className="rounded-2xl border border-border-subtle bg-white/5 p-5">
                  <div className="text-sm font-semibold text-text-primary">{x.t}</div>
                  <div className="mt-2 text-sm text-text-secondary">{x.d}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-10 glass-card p-6" id="contact-form">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Get your control maps</div>
            <div className="mt-3 text-sm text-text-secondary">We can generate a map pack specific to your sector and tech stack.</div>
            <div className="mt-6">
              <ContactForm title="Control maps request" subtitle="Share your frameworks and tool landscape." ctaLabel="Send" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
